<div class="zn-step-content-sections">
  <div [class]="contractSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.Contract.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.Contract.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="contractor">
              {{ (localizationKeyPrefix + '.Contract.Contractor') | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #contractorSelect
              id="contractor"
              [options]="contractorOptions()"
              [optionsLoader]="loadVendors"
              [showSearch]="true"
              (selectedChange)="onContractorChange($event)"
              [localizationResource]="localizationResource"
              [openUp]="false"
            >
            </zn-single-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="contractAssociationSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.ContractAssociation.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.ContractAssociation.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="row">
          <div class="col-6">
            <div class="form-control-container">
              <label class="form-label" for="landContractToAssociate">
                {{ (localizationKeyPrefix + '.ContractAssociation.LandContractToAssociate') | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #landContractSelect
                id="landContractToAssociate"
                [options]="landContractOptions()"
                [optionsLoader]="loadLandContracts"
                [showSearch]="true"
                (selectedChange)="onLandContractChange($event)"
                [localizationResource]="localizationResource"
                [openUp]="false"
              >
              </zn-single-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-control-container">
              <label class="form-label" for="landContractType">
                {{ (localizationKeyPrefix + '.ContractAssociation.LandContractType') | abpLocalization }}
              </label>
              <input
                class="form-control"
                disabled
                id="landContractType"
                type="text"
                maxlength="200"
                [value]=landContractTypeDescription()
                readonly="true"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-control-container">
              <label class="form-label" for="forestContractToAssociate">
                {{ (localizationKeyPrefix + '.ContractAssociation.ForestContractToAssociate') | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #forestContractSelect
                id="forestContractToAssociate"
                [options]="forestContractOptions()"
                [optionsLoader]="loadForestContracts"
                [showSearch]="true"
                (selectedChange)="onForestContractChange($event)"
                [localizationResource]="localizationResource"
                [openUp]="false"
              >
              </zn-single-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-control-container">
              <label class="form-label" for="forestContractType">
                {{ (localizationKeyPrefix + '.ContractAssociation.ForestContractType') | abpLocalization }}
              </label>
              <input
                class="form-control"
                disabled
                id="forestContractType"
                type="text"
                maxlength="200"
                [value]=forestContractTypeDescription()
                readonly="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
